// extracted by mini-css-extract-plugin
module.exports = {"couponMessage":"coupon_couponMessage__3njTC"};